/** Supabase / PostgREST errors are usually `Error`, but some shapes only expose `message`. */
export function messageFromUnknown(e: unknown): string {
  if (e instanceof Error) return e.message
  if (typeof e === "string") return e
  if (e && typeof e === "object") {
    const rec = e as Record<string, unknown>
    if (typeof rec.message === "string" && rec.message) return rec.message
    if (typeof rec.error_description === "string" && rec.error_description) {
      return rec.error_description
    }
    if (typeof rec.details === "string" && rec.details) return rec.details
    if (typeof rec.hint === "string" && rec.hint) return rec.hint
    if (typeof rec.code === "string" && rec.code) return `Error code ${rec.code}`
  }
  return "Something went wrong."
}
